import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { SaversTrailerMovement } from '../../types';

export interface TrailerMovementParams {
  trailerMovementID: number;
}

export const getTrailerMovement = (params: TrailerMovementParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SAVERS}/GetTrailerMovement`,
  });
};

export type SaversTrailerMovementResponse = SaversTrailerMovement[];

export const fetchTrailerMovement = async (params: TrailerMovementParams): Promise<SaversTrailerMovementResponse> => {
  const response: AxiosResponse<SaversTrailerMovementResponse> = await getTrailerMovement(params);
  return response.data;
};
